import { Injectable } from '@angular/core';

import { UserService } from '@frontend/sports/user/feature';

import { EarlyPayoutStates } from '../../my-bets-base/models/early-payout-types';
import { MyBetsBetSlip } from '../../my-bets-base/models/my-bets-viewmodels';

export enum EarlypayoutButtonState {
    Allowed,
    Confirm,
    Preparing,
    PaidOut,
    Disabled,
    Completed,
    // eslint-disable-next-line
    Undefined,
}

@Injectable()
export class MyBetsEarlypayoutButtonStateService {
    constructor(private userService: UserService) {}

    buttonState(betslip: MyBetsBetSlip): EarlypayoutButtonState {
        const earlyPayout = betslip.earlyPayout;
        const earlyPayoutState = earlyPayout && earlyPayout.state;
        if (!earlyPayoutState) {
            return EarlypayoutButtonState.Undefined;
        }

        switch (earlyPayoutState) {
            case EarlyPayoutStates.Disabled:
            case EarlyPayoutStates.PermanentlyDisabled:
                return EarlypayoutButtonState.Disabled;
            case EarlyPayoutStates.Preparing:
                return EarlypayoutButtonState.Preparing;
            case EarlyPayoutStates.PaidOut:
                return EarlypayoutButtonState.PaidOut;
            case EarlyPayoutStates.Completed:
                return EarlypayoutButtonState.Completed;
        }

        if (earlyPayout && this.userService.columnSize > earlyPayout.value) {
            return EarlypayoutButtonState.Disabled;
        }

        if (betslip.isRecoveringAfterEditBet) {
            return EarlypayoutButtonState.Disabled;
        }

        switch (earlyPayoutState) {
            case EarlyPayoutStates.Allowed:
                return EarlypayoutButtonState.Allowed;
            case EarlyPayoutStates.Confirm:
                return EarlypayoutButtonState.Confirm;
            default:
                return EarlypayoutButtonState.Undefined;
        }
    }
}
